module.exports = __webpack_public_path__ + "img/Zimbabwe.d87ee868.png";